
import { useQuery } from "@tanstack/react-query";
import * as api from "@/lib/api";
import { queryKeys } from "@/lib/query-keys";

export function useMyExams() {
  return useQuery({
    queryKey: queryKeys.exams.mine(),
    queryFn: api.getExams,
    staleTime: 60 * 1000,
  });
}

export function useAllExams() {
  return useQuery({
    queryKey: queryKeys.exams.catalog(),
    queryFn: api.getAllExams,
    staleTime: 5 * 60 * 1000,
  });
}

export function useExam(slug: string) {
  return useQuery({
    queryKey: queryKeys.exams.detail(slug),
    queryFn: () => api.getExam(slug),
    enabled: !!slug,
    staleTime: 5 * 60 * 1000,
  });
}
